'use es6';

import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
import { useLocation } from 'react-router-dom';
import { useNamedRoute } from '../../hooks/routeStateHooks';
import HeadingNav from './HeadingNav';
import { useUserAttributes } from '../../features/userAttributes';
import getLang from 'I18n/utils/getLang';
import { isNewCatalogUser, isNonEnglishSelected } from '../../utils/utils';
import { wizardEnabledLanguages } from '../../constants/WizardRecommendationConstants';
import { Route } from '../../features/routing';

const DashboardPageLayoutRoute = (_ref) => {
  let {
    component: Component,
    maybeBanner: MaybeBanner,
    headerSearch,
    path,
    titleKey,
    searchResultsRedirect,
    name
  } = _ref,
      rest = _objectWithoutPropertiesLoose(_ref, ["component", "maybeBanner", "headerSearch", "path", "titleKey", "searchResultsRedirect", "name"]);

  useNamedRoute({
    name,
    path
  });
  const location = useLocation();
  const {
    userAttributesLoaded
  } = useUserAttributes();
  const isWizardEnabledLanguage = wizardEnabledLanguages.includes(getLang()) && !isNonEnglishSelected(location.search);
  const newCatalogUser = isNewCatalogUser(location.search); // Delaying load to avoid flash of catalog page before wizard takeover pops up

  const shouldDelayLoad = newCatalogUser && isWizardEnabledLanguage;
  return shouldDelayLoad && !userAttributesLoaded ? null : /*#__PURE__*/_jsx(Route, Object.assign({
    path: path
  }, rest, {
    render: props => /*#__PURE__*/_jsx("div", {
      children: /*#__PURE__*/_jsxs("div", {
        "data-test-id": "dashboard-layout",
        children: [/*#__PURE__*/_jsx(HeadingNav, {
          searchResultsRedirect: searchResultsRedirect,
          titleKey: titleKey,
          withSearch: headerSearch
        }), MaybeBanner && /*#__PURE__*/_jsx(MaybeBanner, {}), /*#__PURE__*/_jsx(Component, Object.assign({}, props))]
      })
    })
  }));
};

DashboardPageLayoutRoute.propTypes = Route.propTypes;
export default DashboardPageLayoutRoute;